import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormCrearTraspaso from './FormCrearTraspaso';

import updateTraspasoPorId from '../../../graphql/mutations/rrhh/updateTraspasoPorId.graphql';
import getTraspasoPorId from '../../../graphql/querys/rrhh/getTraspasoPorId.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(updateTraspasoPorId, {
    name: 'updateTraspasoPorId',
  })
)
class EditarTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      traspaso: {},
      loading: true,
    };

    this.props.client
      .query({
        query: getTraspasoPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const traspaso = res.data.getTraspasoPorId;
        this.setState({
          loading: false,
          traspaso: traspaso,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.onCancel = this.onCancel.bind(this);
  }

  guardarTraspaso = traspaso => {
    // console.log("El traspaso para editar es......");
    // console.log(traspaso);
    this.setState(
      {
        traspaso: {
          ...this.state.traspaso,
          ...traspaso,
        },
      },
      function() {
        let nuevoTraspaso = traspaso;

        nuevoTraspaso.fechaEstimada = nuevoTraspaso.fechaEstimada.toDate();
        delete nuevoTraspaso.__typename;
        delete nuevoTraspaso._id;

        this.props
          .updateTraspasoPorId({
            variables: {
              _id: this.props.match.params.id,
              nuevoTraspaso: nuevoTraspaso,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del traspaso',
            });

            this.props.history.push('/rrhh/traspasos');
          })
          .catch(err => {
            console.log('Error en la actualizacion del traspaso');
            console.log(err);

            Modal.error({
              title: 'Error en la actualizacion de los datos del traspaso',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Traspaso</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Traspaso
          </h2>
          <br />
          <div style={estiloContent}>
            <FormCrearTraspaso
              className="formularios"
              onSubmit={this.guardarTraspaso}
              onAnterior={() => this.props.history.push('/rrhh/traspasos')}
              datos={this.state.traspaso}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarTraspaso);
